import { Map as ImmutableMap } from 'immutable';
import { handleActions } from 'flux-actions';
import { AlertActionTypes } from '../actions/AlertActions';
import Alert from '../records/Alert';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped dep
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const initialState = ImmutableMap();
export const getAlertSeverity = action => {
  if (!action.payload) {
    return undefined;
  }
  const split = action.payload.alertMessageKey.split('_');
  const requestSuffix = split[split.length - 1];
  switch (requestSuffix) {
    case 'SUCCESS':
      return 'success';
    case 'FAILURE':
      return 'danger';
    default:
      return 'info';
  }
};
const getAlertTitle = severity => {
  if (severity === 'success') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.alerts.success"
    });
  } else if (severity === 'danger') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.alerts.error"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "userPreferences.alerts.info"
  });
};
const getHelpLinkMaybe = action => action.payload && action.payload.helpUrl ? /*#__PURE__*/_jsxs("span", {
  children: [' ', /*#__PURE__*/_jsx(KnowledgeBaseButton, {
    url: action.payload.helpUrl
  })]
}) : null;
export const handleCreateActiveAlert = (state, action) => {
  if (!action.payload) {
    return state;
  }
  const alertMessageKey = action.payload.alertMessageKey;
  const alertSeverity = getAlertSeverity(action);
  // @ts-expect-error untyped dep
  if (I18n.lookup(`userPreferences.alerts.${alertMessageKey}.title`)) {
    return state.set(alertMessageKey, new Alert({
      id: alertMessageKey,
      // @ts-expect-error untyped dep
      message: I18n.lookup(`userPreferences.alerts.${alertMessageKey}.message`) && /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `userPreferences.alerts.${alertMessageKey}.message`,
          options: {
            data: action.payload.props
          }
        }), getHelpLinkMaybe(action)]
      }),
      type: alertSeverity,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `userPreferences.alerts.${alertMessageKey}.title`,
        options: {
          data: action.payload.props
        }
      })
    }));
  }
  return state.set(alertMessageKey, new Alert({
    id: alertMessageKey,
    message: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `userPreferences.alerts.${alertMessageKey}`,
        options: {
          data: action.payload.props
        }
      }), getHelpLinkMaybe(action)]
    }),
    type: alertSeverity,
    titleText: getAlertTitle(alertSeverity)
  }));
};
export default handleActions({
  [AlertActionTypes.CREATE_AUTOMATIC_DISMISSIBLE_ALERT](state, action) {
    return handleCreateActiveAlert(state, action);
  },
  [AlertActionTypes.CREATE_DISMISSIBLE_ALERT](state, action) {
    return handleCreateActiveAlert(state, action);
  },
  [AlertActionTypes.CLEAR_ALERT](state, action) {
    if (!action.payload) {
      return state;
    }
    const alertId = action.payload;
    return state.delete(alertId);
  }
}, initialState);